import { render, staticRenderFns } from "./ProfilePage_avatar.vue?vue&type=template&id=32920728&scoped=true&"
import script from "./ProfilePage_avatar.vue?vue&type=script&lang=js&"
export * from "./ProfilePage_avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32920728",
  null
  
)

export default component.exports